import { useState, useRef } from "react";
import Config from "src/Constants/Config";
import "./index.sass";

const LastPage = () => {
  const [activeVideo, setActiveVideo] = useState<number | null>(null);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

  const handlePlay = (index: number) => {
    if (activeVideo !== null && videoRefs.current[activeVideo]) {
      videoRefs.current[activeVideo]?.pause();
    }
    setActiveVideo(index);
  };

  const items = [
    {
      title: "Amazon Q business - Sharepoint connector",
      videoSrc: "use_1.mp4",
    },
    {
      title: "Telecom AI Ops",
      videoSrc: "use_2.mp4",
    },
    {
      title: "Telecom AI Ops - Short video",
      videoSrc: "use_3.mp4",
    },
  ];

  return (
    <div id="last-page">
      <div className="last-page-title">OTHER USE CASES</div>
      <div className="last-page-list">
        {items.map((item, index) => (
          <div key={index} className="last-page-item">
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              controls
              muted
              style={{ height: "var(--height-300)" }}
              src={`${Config.BASE_URL}/videos/${item.videoSrc}`}
              onPlay={() => handlePlay(index)}
            ></video>
            <div className="last-page-item-title">{item.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LastPage;
